import Swiper, { EffectFade, Autoplay, Thumbs } from 'swiper';
Swiper.use([EffectFade, Autoplay, Thumbs]);

export default () => {
    let container = document.querySelector('.front-page-header__slider');

    if (container) {
        let mainSlider = galleryTop(container);
        sliderIndicator(mainSlider);

        window.addEventListener('resize', () => {
            sliderIndicator(mainSlider);
        });
    }
}

let galleryTop = (container) => {
    let swiper = new Swiper(container, {
        allowTouchMove: false,
        observer: true,
        observeParents: true,
        loop: true,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
        thumbs: {
            swiper: galleryTopNavigation()
        }
    });

    let prev = document.querySelector('.front-page-header__bottom .swiper-button-prev');
    let next = document.querySelector('.front-page-header__bottom .swiper-button-next');

    prev.addEventListener('click', () => {
        swiper.slidePrev(500, false);
    });

    next.addEventListener('click', () => {
        swiper.slideNext(500, false);
    });

    return swiper;
}

let galleryTopNavigation = () => {
    let swiper = new Swiper('.front-page-header__slider-navigation', {
        slidesPerView: 1,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            }
        }
    });

    return swiper;
}

let sliderIndicator = (swiper) => {
    let indicator = document.querySelector('.front-page-header__bottom-indicator');

    if (window.innerWidth < 640) {
        indicator.style.width = '';
        indicator.style.transform = '';
        return false;
    }

    let slide = document.querySelector('.front-page-header__slider-navigation .swiper-slide-thumb-active');
    let slideWidth = slide.clientWidth;
    indicator.style.width = slideWidth + 'px';

    let moveIndicator = () => {
        let wrapper = document.querySelector('.front-page-header__slider-navigation .swiper-wrapper');
        let nodes = Array.prototype.slice.call( wrapper.querySelectorAll('.swiper-slide-visible') );
        let liRef = wrapper.querySelectorAll('.swiper-slide-thumb-active')[0];
        let index = nodes.indexOf(liRef);
        indicator.style.transform = 'translateX(' + slideWidth * index + 'px)';
    };

    moveIndicator();

    swiper.on('slideChange', () => {
        moveIndicator();
    });
};
